import React from 'react'
import { withLayouts } from 'react-dx'

import styles from './index.module.scss'

import type { MusicMetadataSuccess } from '@/pages/tad.ai/_components/MusicItem/_components/InternalMusicItem/_components/MusicItemSuccess'

import AntdLayout from '@/pages/tad.ai/_layout/layouts/AntdLayout'
import SiteSpecificContextLayout from '@/pages/tad.ai/_layout/layouts/SiteSpecificContextLayout'
import AudioPlayerFull from '@/pages/tad.ai/_components/AudioPlayer/Full'
import MusicDetail from '@/pages/tad.ai/_components/MusicDetail'
import { useLayoutStore } from '@/pages/tad.ai/_layout/store'
import { useInWhichPage } from '@/hooks/useInWhichPage'

import { useGlobalAudioPlayer } from '@/hooks/audio/store';
import { useRouter } from '@/hooks/routes';
import { useEffect } from 'react';
import { cls } from 'tagged-classnames-free';
export interface TadAudioPlayerProps {}

const TadAudioPlayer: React.FC<TadAudioPlayerProps> = () => {
  const audioPlayer = useGlobalAudioPlayer()
  const toggleShowDetail = useGlobalAudioPlayer(
    (state) => state.toggleShowDetail,
  )
  const unLoad = useGlobalAudioPlayer((state) => state.unLoad)
  const router = useRouter()
  const { showSidebar } = useLayoutStore()
  const { inDetailPage } = useInWhichPage()
  useEffect(() => {
    const handleRouteChange = () => {
      toggleShowDetail(false)
      if (inDetailPage) {
        unLoad()
      }
    }

    // 监听路由变化事件
    router.events.on('routeChangeStart', handleRouteChange)

    // 如果组件卸载，移除监听
    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [inDetailPage, router.events, toggleShowDetail, unLoad])

  return (
    <div className={`fixed inset-x-0 bottom-0 z-10`}>
      <div
        className={cls`absolute bottom-0 mb-3 w-full ${showSidebar ? 'sm:ml-[72px] sm:w-[calc(100%-72px)]' : ''} ${styles.fullscreenPanel} ${audioPlayer.showDetail ? styles.expanded : ''}`}
      >
        {audioPlayer.meta && audioPlayer.showDetail && (
          <MusicDetail data={audioPlayer.meta as MusicMetadataSuccess} />
        )}
      </div>
      <AudioPlayerFull />
    </div>
  )
}

const LayoutsTadAudioPlayer = withLayouts(TadAudioPlayer, [
  SiteSpecificContextLayout,
  AntdLayout,
])

export default LayoutsTadAudioPlayer
